import styled from "styled-components";

export const ContainerFooter = styled.footer`
   max-width: 1400px;
   width: 100%;
   display: flex;
   flex-direction: column;
   align-items: center;

   .image-footer-mobile {
      display: none;
   }
   
   .image-footer-desktop {
      display: inline-block;
   }

   .container-infos-contato {
      max-width: 580px;
      margin: 50px 0px;
      display: flex;
      flex-direction: column;

      .image-footer {
         width: 100%;
         margin-bottom: 10px;
      }

      .title {
         margin-bottom: 30px;
         margin-top: -10px;
         font-style: var(--unnamed-font-style-normal);
         font-weight: var(--unnamed-font-weight-600);
         font-size: var(--unnamed-font-size-18);
         line-height: var(--unnamed-line-spacing-18);
         letter-spacing: var(--unnamed-character-spacing-1);
         color: var(--unnamed-color-d5b68f);
         text-transform: uppercase;
      }

      .description {
         font-weight: var(--unnamed-font-style-normal);
         font-size: var(--unnamed-font-size-14);
         line-height: var(--unnamed-line-spacing-24);
         letter-spacing: var(--unnamed-character-spacing-0);
         color: var(--unnamed-color-4a3f32);
         margin: 0;
      }
      .description b{
         color: var(--unnamed-color-827566);

      }
   }

   .container-direitos {
      width: 100%;
      padding: 50px 30px;
      background: #F7F4F0 0% 0% no-repeat padding-box;

      p {
         text-align: center;
         font-weight: var(--unnamed-font-style-normal);
         font-size: var(--unnamed-font-size-14);
         line-height: var(--unnamed-line-spacing-24);
         letter-spacing: var(--unnamed-character-spacing-0);
         color: var(--unnamed-color-4a3f32);
         margin: 0;

         /* strong {
            a {
               color: ;
            }
         } */
      }

      .signature {
         text-decoration: none;
         color: #bb2025;
      }
   }

   @media only screen and (max-width: 800px) {
      .image-footer-mobile {
         display: inline-block;
      }

      .image-footer-desktop {
         display: none;
      }
   }

   @media (min-width: 800px) {
      .container-infos-contato {
         width: 100%;
         display: flex;
         flex-direction: column;
         justify-content: space-between;
         align-items: center;
         padding: 0px 15px;
         max-width: 1400px;
         margin-bottom: 100px;

         .image-footer {
            width: 60%;
            margin-bottom: 0px;
         }

         .title {
            margin-top: 0px;
         }

         .container-posi-footer {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 40px;
         }
      }
   }
 `;